import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import _ from "lodash";
import { useForm, Controller } from "react-hook-form";
import TextEditor from "../_Components/CkEditor/Index";
import { useState } from "react";

const AddImageLabelModal = ({
  showImageLabelModal,
  setShowImageLabelModal,
  setImageLabels,
  setValue,
  selectedImageLabelId,
  selectedImageLabel,
  imageLabels,
}) => {
  const handleClose = () => {
    setShowImageLabelModal(false);
  };

  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
    watch,
  } = useForm({
    defaultValues: {
      type: 1,
      labelText: selectedImageLabel?.LabelText || undefined,
      backgroundColor: selectedImageLabel?.BackgroundColor || "#ff6600",
    },
  });
  const onSubmit = async (data) => {
    try {
      if (_.isEmpty(selectedImageLabel)) {
        setImageLabels((prev) => {
          setValue("imageLabelList", [
            ...prev,
            {
              LabelText: data.labelText,
              BackgroundColor: data.backgroundColor,
            },
          ]);
          return [
            ...prev,
            {
              LabelText: data.labelText,
              BackgroundColor: data.backgroundColor,
            },
          ];
        });
      } else {
        const updatedImageLabelList = imageLabels?.map((item, index) => {
          if (selectedImageLabelId == index) {
            return { LabelText: data.labelText, BackgroundColor: data.backgroundColor };
          } else {
            return item;
          }
        });
        setImageLabels([...updatedImageLabelList]);
        setValue("imageLabelList", [...updatedImageLabelList]);
      }

      handleClose();
    } catch (error) {
    }
  };

  return (
    <div>
      <div className="card-body pt-3 pb-0">
        {/* Start Modal */}
        <Modal centered onHide={handleClose} show={showImageLabelModal}>
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">ایجاد برچسب جدید</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Col xs="12">
                <Row>
                  <Col xs="12">
                    <p className="mb-4">برچسب : </p>
                    <Controller
                      name="labelText"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextEditor
                          data={value || ""}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            onChange(data);
                          }}
                        />
                      )}
                    />
                  </Col>
                  <Col className="mt-5">
                    <p className="mb-3">رنگ پس زمینه : </p>
                    <div className="d-flex align-items-center">
                      <Controller
                        name="backgroundColor"
                        control={control}
                        render={({ field }) => {
                          // تابع کمکی برای افزودن # اگر نبود
                          const formatColor = (value) => {
                            if (!value) return "";
                            return value.startsWith("#") ? value : "#" + value;
                          };

                          // اعتبارسنجی ساده رنگ هگز (3 یا 6 رقم بعد از #)
                          const isValidHexColor = (color) => /^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/.test(color.trim());

                          const handleTextChange = (e) => {
                            let val = e.target.value.trim();
                            if (val === "") {
                              field.onChange("");
                              return;
                            }
                            val = formatColor(val);
                            if (isValidHexColor(val)) {
                              field.onChange(val);
                            } else {
                            }
                          };

                          const handlePaste = (e) => {
                            let pasteData = e.clipboardData.getData("text").trim();
                            pasteData = formatColor(pasteData);
                            if (!isValidHexColor(pasteData)) {
                              e.preventDefault();
                            } else {
                              field.onChange(pasteData);
                            }
                          };

                          return (
                            <>
                              <input
                                type="color"
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e);
                                }}
                                className="form-control"
                                style={{ width: "150px", height: "40px" }}
                              />
                              <input
                                type="text"
                                value={field.value}
                                onChange={handleTextChange}
                                onPaste={handlePaste}
                                placeholder="#000000"
                                className="form-control ml-3 ltr text-center"
                              />
                            </>
                          );
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ذخیره
              </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default AddImageLabelModal;
